<!-- /****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
-->
@if (homeComponent.isAppBusy) {
  <div class="spinner-section">
    <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
}
<div class="supp-user-list">
  <supplier-common-header [data]="headerData" (onAction)="headerAction($event)"></supplier-common-header>
  <div class="supp-user-list-card">
    @if (dataSourceLength > 0) {
      <div class="mat-elevation-z1" style="margin-top: 20px;">
        <mat-table #table [dataSource]="dataSource">
          <ng-container matColumnDef="firstName">
            <mat-header-cell *matHeaderCellDef class="column-header"> {{'supplier.userlist.firstName' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.firstName}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="lastName">
            <mat-header-cell *matHeaderCellDef class="column-header"> {{'supplier.userlist.lastName' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.lastName}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="userCode">
            <mat-header-cell *matHeaderCellDef class="column-header"> {{'supplier.userlist.userCode' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.userCode}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef class="column-header"> {{'supplier.userlist.email' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.email}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="phoneNumber">
            <mat-header-cell *matHeaderCellDef class="column-header"> {{'supplier.userlist.phoneNumber' | translate}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.phoneNumber}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell class="text-center column-header" *matHeaderCellDef> {{'supplier.userlist.actions' |
            translate}} </mat-header-cell>
            <mat-cell sclass="text-center" *matCellDef="let element">
              <button mat-button [matMenuTriggerFor]="menu">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editUser(element)" *PreAuthorize="'SupplierApi_updateUser'">
                  <mat-icon>edit</mat-icon>
                  {{'supplier.userlist.edit' | translate}}
                </button>
                <button mat-menu-item *PreAuthorize="'SupplierApi_deleteSupplierUser'" (click)="deleteUser(element)">
                  <mat-icon>delete</mat-icon>
                  {{'supplier.userlist.delete' | translate}}
                </button>
                <button mat-menu-item (click)="assignRoles(element)">
                  <mat-icon>assignment_ind</mat-icon>
                  {{'supplier.userlist.assignRoles' | translate}}
                </button>
                <button mat-menu-item *PreAuthorize="'HierarchyApi_getUserMappedOrganizationHierarchy'" (click)="mapUserToHierarchy(element)">
                  <mat-icon>person_add</mat-icon>
                  {{'supplier.userlist.mapuser' | translate}}
                </button>
                <button mat-menu-item *PreAuthorize="'GroupsApi_updateUserGroups'" (click)="mapUserToGroup(element)">
                  <mat-icon>person_add</mat-icon>
                  {{'supplier.userlist.mapusertogroup' | translate}}
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
        <mat-paginator [length]="dataSourceLength" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="setPageSize($event)">
        </mat-paginator>
      </div>
    } @else {
      @if (!homeComponent.showSpinner) {
        <div class="users-not-found">
          <mat-card>
            <mat-card-content style="display: flex; flex-direction: column">
              <div style="display: flex; flex-direction: row">
                <div style="justify-content: center; align-items: center; flex: 1 1 25%; max-width: 25%; box-sizing: border-box">
                </div>
                <div style="display: flex; flex-direction: column; flex: 1 1 75%; max-width: 75%; box-sizing: border-box">
                  <div class="cart-no-product-subtitle">{{'supplier.userlist.noUsersFound' | translate}}</div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      }
    }
  </div>


